import React from "react";
import { Box, BoxProps, IconButton, Modal, ModalProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ShadowPortal from "../../ShadowPortal";

const CustomModal: React.FC<
  {
    onClose?: () => void;
    className?: any;
    boxProps?: BoxProps;
    closeBtn?: boolean;
  } & ModalProps
> = (props) => {
  const { className, children, boxProps, onClose, closeBtn, ...modalProps } =
    props;

  const { sx: boxSx, ...restBoxProps } = boxProps ?? {};
  // const handleClose = (e: React.MouseEvent) => {
  //   if (e.target === e.currentTarget) {
  //     if (onClose) onClose();
  //   }
  // };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <ShadowPortal>
      <Modal onClose={handleClose} {...modalProps}>
        <Box
          {...restBoxProps}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90%",
              md: "700px",
            },
            background: "white",
            display: "grid",
            placeItems: "center",
            padding: "2em",
            borderRadius: 2,
            maxHeight: {
              xs: "80vh",
              sm: "60vh",
            },
            overflow: "auto",
            outline: "none",
            ...boxSx,
          }}
        >
          {closeBtn && (
            <IconButton
              sx={{
                position: "absolute",
                top: ".5rem",
                right: ".5rem",
              }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          )}
          <div className={className}>{children}</div>
        </Box>
      </Modal>
    </ShadowPortal>
  );
};

export default CustomModal;
